import "../stylesheets/App.css";
import "../stylesheets/TempPassword.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./subcomponents/Loader.js";
import PopupMailEnviado from "./subcomponents/PopupMailEnviado.js";

function TempPassword() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordNew, setPasswordNew] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    // Si no hay email guardado (viene desde login/recover), no tiene sentido estar acá
    const raw = localStorage.getItem("user-email");
    if (!raw) {
      navigate("/login");
    }
  }, [navigate]);

  const changePassword = async () => {
    setErrorMsg("");

    const rawEmail = localStorage.getItem("user-email");
    if (!rawEmail) {
      setErrorMsg("El enlace de recuperación no es válido");
      navigate("/login");
      return;
    }

    const email = JSON.parse(rawEmail);

    if (passwordNew !== passwordRepeat) {
      setErrorMsg("Las contraseñas no coinciden");
      return;
    }

    setLoading(true);

    try {
      const item = { email, password, passwordNew };

      // 1) valido que el email exista
      const resultUser = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/getByEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ email }),
        }
      ).then((r) => r.json());

      if (resultUser.status !== 200) {
        setErrorMsg("El enlace de recuperación no es válido");
        return;
      }

      // 2) cambio password
      const result = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/changePassword`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      ).then((r) => r.json());

      if (result.status === 200) {
        setOpenPopup(true);
        // opcional: limpiar user-email para que no se reuse
        // localStorage.removeItem("user-email");
      } else {
        setErrorMsg(result?.data?.errors?.[0]?.msg || "Error al cambiar la contraseña");
      }
    } catch (e) {
      console.log(e);
      setErrorMsg("Ocurrió un error. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <img
        className="temp-password-img"
        src={process.env.PUBLIC_URL + "/images/logo-registro.png"}
        alt=""
      />

      <div className="temp-password-container section-70">
        <h1 className="temp-password-title">Debe definir una nueva contraseña</h1>

        <input
          type="password"
          className="inp"
          placeholder="Contraseña temporal"
          id="password"
          name="password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type="password"
          className="inp"
          placeholder="Nueva contraseña"
          id="passwordNew"
          name="passwordNew"
          onChange={(e) => setPasswordNew(e.target.value)}
        />

        <input
          type="password"
          className="inp"
          placeholder="Repetir nueva contraseña"
          id="passwordRepeat"
          name="passwordRepeat"
          onChange={(e) => setPasswordRepeat(e.target.value)}
        />

        <span className="error-msg">{errorMsg}</span>

        <button type="submit" className="btn lightgreen-btn margin-bottom-10" onClick={changePassword}>
          Cambiar contraseña
        </button>

        <button className="btn black-btn light-lime-btn" onClick={() => navigate("/login")}>
          Cancelar
        </button>
      </div>

      {loading ? <Loader /> : null}

      {openPopup ? (
        <PopupMailEnviado
          title="Contraseña guardada con éxito"
          description="¡Ya puedes volver a jugar!"
          setOpenPopup={setOpenPopup}
        />
      ) : null}
    </>
  );
}

export default TempPassword;
